<template>
  <div class="select-bar-wrapper">
    <div class="name">{{ title }}</div>
    <div class="tags-wrapper">
      <el-checkbox
        @change="handleTag(tag.text, tag.active)"
        :key="i"
        :value="tag.active"
        :disabled="current === maxSelectCount && !tag.active"
        class="tag"
        v-for="(tag, i) in showTags"
      >
        {{ tag.text }}
      </el-checkbox>
      <el-autocomplete
        :disabled="current === maxSelectCount"
        v-model="customTag"
        class="inline-input"
        valueKey="text"
        :fetch-suggestions="queryTags"
        :placeholder="placeholder"
        @select="handleSelect"
        @focus="onFocus"
        style="width: 300px"
      >
        <template #default="{ item }">
          <div class="custom" v-if="item.type === 'custom'">
            <div class="left">自定义：{{ item.text }}</div>
            <div class="right">添加</div>
          </div>
          <div v-else>
            {{ item.text }}
          </div>
        </template>
      </el-autocomplete>
    </div>
    <transition name="zoom-in-top">
      <div v-if="isShowError || showError" class="error">{{ error }}</div>
    </transition>
  </div>
</template>

<script>
import { ACTION_TYPE } from '../../constants';

export default {
  name: 'selectBar',
  props: {
    type: String,
    title: String,
    placeholder: String,
    error: String,
    maxSelectCount: {
      type: Number,
      default: 5
    },
    showTags: {
      type: Array,
      default: () => []
    },
    tags: {
      type: Array,
      default: () => []
    },
    showError: {
      type: Boolean,
      default: false
    },
    // 是否支持自定义标签
    isCustomized: {
      type: Boolean,
      default: true
    }
  },
  inject: [ACTION_TYPE.ADD_TAG, ACTION_TYPE.SELECT_TAG, ACTION_TYPE.REMOVE_TAG],
  data() {
    return {
      customTag: '',
      isShowError: false
    };
  },
  computed: {
    current() {
      return this.showTags.filter(tag => tag.active).length;
    }
  },
  watch: {
    current(val, preVal) {
      this.isShowError = val !== preVal && !val;
    }
  },
  methods: {
    handleTag(tag, active) {
      const { current, type } = this;
      if (current <= 5) {
        if (!active) {
          this[ACTION_TYPE.SELECT_TAG](tag, type);
        } else {
          this[ACTION_TYPE.REMOVE_TAG](tag, type);
        }
      }
    },
    handleSelect(item) {
      const { type } = this;
      this[ACTION_TYPE.ADD_TAG](item.text, type);
      this.customTag = '';
    },
    queryTags(tag, cb) {
      const { isCustomized } = this;
      if (this.tags.length > 0) {
        let custom = null;
        if (tag !== '') {
          const isExist = this.tags.filter(o => o.text.toLowerCase() === tag.toLowerCase()).length > 0;
          if (!isExist && isCustomized) {
            custom = { text: tag, type: 'custom' };
          }
        }
        const tags = this.tags.filter(o => o.text.toLowerCase().indexOf(tag.toLowerCase()) > -1);
        cb(custom ? [custom].concat(tags) : tags);
      } else {
        if (tag !== '') {
          if (isCustomized) {
            cb(this.tags.concat({ text: tag, type: 'custom' }));
          }
        } else {
          cb(this.tags);
        }
      }
    },
    onFocus() {
      this.$emit('onFocus');
    }
  }
};
</script>

<style lang="scss" scoped>
.select-bar-wrapper {
  position: relative;
  margin-bottom: 20px;
  width: 80%;

  .name {
    margin-bottom: 16px;
    font-size: 14px;

    &:before {
      content: '*';
      color: #f55656;
      // margin-right: 4px;
    }
  }

  .tags-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .tag {
      margin-right: 30px;
      padding: 10px 0;
    }

    .el-button {
      & + .el-button {
        margin-left: 0;
      }
    }
  }

  .error {
    position: absolute;
    top: 100%;
    left: 0;
    font-size: 12px;
    color: #eb3c36;
  }

  .zoom-in-top-enter-active,
  .zoom-in-top-leave-active {
    opacity: 1;
    transform: scaleY(1);
    transition: all 300ms cubic-bezier(0.23, 1, 0.32, 1);
    transform-origin: center top;
  }
  .zoom-in-top-enter,
  .zoom-in-top-leave-active {
    opacity: 0;
    transform: scaleY(0);
  }
}

.custom {
  display: flex;
  justify-content: space-between;

  .right {
    color: #1e8dff;
  }
}
</style>
